import React, {useEffect, useRef, useState} from 'react';
import ScratchCard from 'scratch-win-react';
import {useTranslation} from 'react-i18next';
import PotatoHuntOnStartAnimation from "./PotatoHuntOnStartAnimation";
import {lock, unlock} from 'tua-body-scroll-lock'

export default function PotatoHuntStepScratchCard({imagePath, userResponse, selectedCell, onNextStep, setStep}) {

	const {t, i18n} = useTranslation();

	const [width, setWidth] = useState(0);
	const [height, setHeight] = useState(0);
	const [brushSize, setBrushSize] = useState(20);
	const [isOnStart, setIsOnStart] = useState(true);
	const [isComplete, setIsComplete] = useState(false);
	const [isScratchCardComplete, setIsScratchCardComplete] = useState(false);

	const potatoHuntScratchCardRef = useRef(null);
	const scratchCardRef = useRef(null);

	const frontImage = imagePath + "potato-hunt/" + (selectedCell === "odd" ? "Lays_field_selection_plant.jpg" : "Lays_field_selection_soil.jpg");


	const responseType = userResponse.response_type;
	const response = userResponse.response;
	const root = document.getElementsByTagName('html')[0];

	let backImage = null;
	if (responseType === "image") {
		backImage = response;
	}

	function freezePage() {
		if (!isComplete) {
			setIsOnStart(false);
			lock();
		} else {
			lock();
		}
	}

	function unfreezePage() {
		let onCompleteTimerScratchCard = setTimeout(() => {
			unlock();
		}, 400);
		return () => {
			clearTimeout(onCompleteTimerScratchCard);
		};
	}

	useEffect(() => {

		// Set size of Scratch Card
		if (potatoHuntScratchCardRef.current.offsetWidth < 716) {
			setWidth(potatoHuntScratchCardRef.current.offsetWidth);
			setBrushSize(30);
		} else {
			setWidth(716);
			setBrushSize(80);
		}
		setHeight(potatoHuntScratchCardRef.current.offsetHeight);
	}, []);

	useEffect(() => {
		if (root.classList.contains('potato-hunt-scratch-card-fixed-body')) {
			let onCompleteTimer = setTimeout(() => {
				unfreezePage();
			}, 300);
			return () => {
				clearTimeout(onCompleteTimer);
			};
		}
	}, [isComplete]);




	return (
		<div className="potato-hunt-sub-component potato-hunt-scratch-card-component scratch-card-v2">
			<div className="potato-hunt-sub-component--inner">
				<div className="potato-hunt-scratch-card-wrap">
					{/*imageName="potato-hunt/Lays_scratch_animation.gif"*/}
					<PotatoHuntOnStartAnimation
						imagePath={imagePath}
						imageName={'potato-hunt/' + t('Lays_scratch_animation.gif')}
						altText="scratch animation"
						isOnStart={isOnStart}/>

					{!isScratchCardComplete && (
						<div className="butterfly-animation">
							<img src={imagePath + "potato-hunt/Lays_Field_Animation_Butterflies_gif.gif"} alt=""/>
						</div>
					)}


					<div ref={potatoHuntScratchCardRef}
						 onTouchStart={() => {
							 freezePage();
						 }}
						 onTouchEnd={() => {
							 unfreezePage();
						 }}
						 onMouseDown={() => {
							 freezePage();
						 }}
						 onMouseUp={() => {
							 unfreezePage();
						 }}

						 className="potato-hunt-scratch-card">
						<ScratchCard ref={scratchCardRef}
									 width={width}
									 height={height}
									 brushSize={brushSize}
									 finishPercent={65}
									 onComplete={() => {
										 setIsComplete(true)
										 setStep(4.5)
										 setIsScratchCardComplete(true)
									 }}
									 image={frontImage}>
							<div>
								<img src={backImage}/>
							</div>
						</ScratchCard>
					</div>
				</div>
			</div>
			<div className={`potato-hunt-sub-component-action grid-box ${isScratchCardComplete ? 'show' : 'hide'}`}>
				<div>
					<div>
						<a onClick={() => {
							setStep(5)
						}} className="btn btn-primary cta primary-cta filled">
							{t("Next")}
						</a>
					</div>
				</div>
			</div>
		</div>
	)
}
